/**
 * Application stores for Svelte
 */

import { writable, derived } from 'svelte/store'

// Current tab state
export const currentTab = writable('overview') // 'workout' | 'overview' | 'database'

// Current view state
export const currentView = writable('home') // 'home' | 'workoutForm' | 'workoutList' | 'exerciseManager'

// Workout form mode and data
export const workoutFormMode = writable('create') // 'create' | 'edit'
export const editingWorkoutId = writable(null)
export const startingTemplateId = writable(null) // Template ID when creating workout from template

// Sync status
export const syncStatus = writable({
  isSyncing: false,
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  message: '',
  success: true
})

// Pending sync count
export const pendingSyncCount = writable(0)

// Recent workouts for home page
export const recentWorkouts = writable([])

// Navigation functions
export function navigateTo(view, options = {}) {
  if (view === 'workoutForm') {
    workoutFormMode.set(options.mode || 'create')
    editingWorkoutId.set(options.workoutId || null)
    startingTemplateId.set(options.templateId || null)
  }
  currentView.set(view)
}

export function goHome() {
  currentView.set('home')
}

// Tab navigation functions
export function switchTab(tabName) {
  currentTab.set(tabName)
  // Reset to home view when switching tabs
  currentView.set('home')
}
